// extracted by mini-css-extract-plugin
module.exports = {"module":"styles_module__1sTHV","title":"styles_title__16tsi","subtitle":"styles_subtitle__31fWT","closedrawer":"styles_closedrawer__3uKi8","closetitle":"styles_closetitle__2q6wl"};